<template>
  <div class="dropdown">
    <Popper
      v-model:open="open"
      :placement="placement"
    >
      <div class="menu menu--dropdown">
        <ul class="menu__items">
          <li
            v-for="(item, index) in items"
            :key="index"
            :class="joinClasses('menu-item', ['dropdown', ...(item.modifiers||[])])"
          >
            <router-link
              v-if="item.to"
              class="menu-item__link"
              :to="item.to"
              @click.passive="clickItem(item)"
            >
              <div class="menu-item__label">
                {{ item.label }}
              </div>
            </router-link>
            <a
              v-else
              class="menu-item__link"
              :href="item.path || 'javascript:void(0);'"
              :target="item.target"
              @click="clickItem(item)"
            >
              <div class="menu-item__label">
                {{ item.label }}
              </div>
            </a>
          </li>
        </ul>
      </div>

      <template #trigger>
        <div class="dropdown__trigger">
          <slot />
        </div>
      </template>
    </Popper>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';

import joinClasses from '@/functions/join_classes';

import Popper from '@/components/generic/popper.vue';

defineProps({
  items: { type: Array, required: true },
  placement: { type: String, default: 'bottom' },
  target: { type: String, default: '', required: false }
});
const emit = defineEmits(['click-item', 'open']);

const open = ref(false);

watch(open, (value) => {
  emit('open', value);
});

function clickItem(item) {
  open.value = false;
  emit('click-item', item);
}
</script>
